import { palette } from '@77sol/styles'

export default palette
